import { atom } from 'recoil';
import { IRouterStep, IStation } from '@shared/types/productionSchedule';
import { IRunner, IWorkOrder } from '../../features/Orders/types';

export const stationUserIdAtom = atom<IStation[]>({
  key: 'stationUserIdAtom',
  default: [],
});

export const routerStepsAtom = atom<IRouterStep[]>({
  key: 'routerStepsAtom',
  default: [],
});

export const queueItemsAtom = atom<number>({
  key: 'queueItemsAtom',
  default: 0,
});

export const productionItemsAtom = atom<number>({
  key: 'productionItemsAtom',
  default: 0,
});

export const routerMachineTypeAtom = atom<'All'|'ANNI'|'ANDI'>({
  key: 'routerMachineType',
  default: 'All',
});

export const inProcessValueAtom = atom<number>({
  key: 'inProcessValueAtom',
  default: 0,
});

export const currentRunnerAtom = atom<IRunner>({
  key: 'currentRunnerAtom',
  default: {
    id: '',
    history: [],
    notes: '',
    runnerNumber: 0,
    partCount: 0,
    partCounts: [],
    toppedOrBound: false,
    step: '',
    completed: false,
    stepNotes: {},
    machine: 'any',
    parts: [],
  },
});

export const currentRunnerOpenAtom = atom<string[]>({
  key: 'currentRunnerOpenAtom',
  default: ['0'],
});

export const splitShopOrderAtom = atom<boolean>({
  key: 'splitShopOrderAtom',
  default: false,
});

export const runnerWorkOrdersAtom = atom<IWorkOrder[]>({
  key: 'runnerWorkOrdersAtom',
  default: [],
});

export const searchModalAtom = atom<boolean>({
  key: 'searchModalAtom',
  default: false,
});

export const initiateScanAtom = atom<boolean>({
  key: 'initiateScanAtom',
  default: false,
});

export const messageAcknolwedgeAtom = atom<boolean>({
  key: 'messageAcknolwedgeAtom',
  default: false,
});
